import React, { useEffect } from "react";
import "./Banner.scss";

export default function Banner() {
  const carouselItems = [
    {
      desktopImage: "/assets/img/slider/desktop2.jpg",
      mobileImage: "/assets/img/slider/mobile3.jpg",
      heading: "Tyre",
    },
    {
      desktopImage: "/assets/img/slider/Automobile-LP.jpg",
      mobileImage: "/assets/img/slider/automobile.jpg",
      heading: "Automobile Solutions",
    },
    {
      desktopImage: "/assets/img/slider/Chemicals-LP.jpg",
      mobileImage: "/assets/img/slider/chemicals.jpg",
      heading: "Chemicals",
    },
    {
      desktopImage: "/assets/img/slider/Metals-and-minerals-LP.jpg",
      mobileImage: "/assets/img/slider/metals-and-minerals.jpg",
      heading: "Metals & Minerals",
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="hero-section">
      <div
        id="hero-slide"
        className="carousel slide carousel-fade"
        data-bs-ride="carousel"
        data-bs-interval="3500"
      >
        <div className="carousel-inner">
          {carouselItems.map((item, index) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <picture>
                <source media="(max-width:560px)" srcSet={item.mobileImage} />
                <img
                  src={item.desktopImage}
                  className="carousel-image"
                  alt={item.heading}
                />
              </picture>

              <div className="overlay"></div>

              <div className="banner-content">
                <h1>{item.heading}</h1>
                <div className="line"></div>
              </div>
            </div>
          ))}
        </div>

        <button
          className="carousel-control-prev custom-arrow"
          type="button"
          data-bs-target="#hero-slide"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon"></span>
        </button>

        <button
          className="carousel-control-next custom-arrow"
          type="button"
          data-bs-target="#hero-slide"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon"></span>
        </button>
      </div>
    </section>
  );
}